import React, { useEffect, useState } from 'react';
import { CarousalImageAdd, CarousalImageGet } from '../../Services/allApi';
import { toast, ToastContainer } from 'react-toastify';

function CarousalImage() {
  const [initialImages, setInitialImages] = useState([]);
  const [images, setImages] = useState([]);
  const [fileObjects, setFileObjects] = useState({});
  const [selectedImage, setSelectedImage] = useState(null);
  const [isImageUploaded, setIsImageUploaded] = useState(false);
  const [countFive, setCountFive] = useState([0, 1, 2, 3, 4])
  const baseUrl = process.env.REACT_APP_BASEURL
  // handle the changing images , show current updated images preview
  const handleImageChange = (e, index) => {
    const file = e.target.files[0];
    if (file) {
      const newImages = [...images];
      newImages[index] = URL.createObjectURL(file);
      setImages(newImages);
      const newFileObjects = { ...fileObjects, [`${index + 1}`]: file };
      setFileObjects(newFileObjects);
      setIsImageUploaded(true);
    }
  };
  // API to upload images
  const handleUpload = async () => {
    const formData = new FormData();
    const token = sessionStorage.getItem('access_token');
    const reqHeader = {
      "Authorization": ` ${token}`
    };
    Object.keys(fileObjects).forEach(key => {
      formData.append(key, fileObjects[key]);
    });
    try {
      const result = await CarousalImageAdd(formData, reqHeader);
      console.log(result);
      if (result?.status == 200) {
        toast.success('Carousal Image Upload successful')
        console.log('succ');
      }
      else {
        toast.error(result?.response?.data?.message ?? 'There was an error updating carousal image')
      }
      // Handle successful upload here (e.g., show a success message or reset state)
    } catch (error) {
      console.error("Error uploading images:", error);
      toast.error('An unexpected error occurred')
      // Handle upload error here (e.g., show an error message)
    }
  };
  // function to show images in full size
  const openFullSizeImage = (image) => {
    setSelectedImage(image);
  };
  const closeFullSizeImage = () => {
    setSelectedImage(null);
  };
  useEffect(() => {
    getImageList()
  }, [])
  // get carousal images initially
  const getImageList = async () => {
    const token = sessionStorage.getItem('access_token');
    const reqHeader = {
      "Authorization": ` ${token}`
    };
    const res = await CarousalImageGet(reqHeader)
    console.log(res);
    const newimarray = res?.data?.map((item) => {
      return item?.home_image
    })
    console.log(newimarray);
    const mapedImg = newimarray?.map((item) => {
      return baseUrl + item
    })
    console.log(mapedImg);
    setInitialImages(mapedImg)
    setImages(mapedImg)
  }

  return (
    <>
      <div className='flex flex-col justify-center items-center pt-2'>
        <h3 className='text-blue-700 text-xl font-bold pb-4 text-center'>Upload 5 carousel images</h3>
        <div className='flex flex-row justify-evenly items-center w-full flex-wrap'>
          {countFive?.map((it, index) => (
            <label htmlFor={`im${index}`} className='w-1/6 h-52' key={index}>
              <div className='w-full h-full border p-2 border-dashed border-blue-500 rounded flex flex-col items-center'>
                <img src={images[index]} alt="" className=' w-full mb-2' style={{ height: '73%' }} />
                <div className='flex flex-col items-center'>
                  <span className='text-sm text-blue-500 text-center mb-2'>Click here to upload new image</span>
                  <button
                    type='button'
                    onClick={() => openFullSizeImage(images[index])}
                    className='bg-blue-500 text-white px-4 text-sm rounded-lg hover:bg-blue-700 transition duration-300'>
                    View
                  </button>
                </div>
              </div>
              <input
                type="file"
                id={`im${index}`}
                style={{ visibility: 'hidden' }}
                onChange={(e) => handleImageChange(e, index)}
              />
            </label>
          ))}
        </div>
        {isImageUploaded && (
          <button
            onClick={handleUpload}
            className='bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition duration-300 mt-5'>
            Upload Images
          </button>
        )}
        {selectedImage && (
          <div className='fixed inset-0 bg-black bg-opacity-70 flex justify-center items-center z-50'>
            <div className='relative max-w-full max-h-full p-4'>
              <img
                src={selectedImage}
                alt="Full Size"
                className='max-w-full max-h-screen object-contain'
              />
              <button
                onClick={closeFullSizeImage}
                className='absolute top-4 right-4 bg-white text-black px-6 py-2 rounded-lg'>
                Back
              </button>
            </div>
          </div>
        )}
      </div>
      <ToastContainer style={{ zIndex: '9999' }} />
    </>
  );
}

export default CarousalImage;
